import { IntrospectionFragmentMatcher } from "apollo-cache-inmemory";
import introspectionQueryResultData from "./../graphql/fragmentTypes.json";

const fragmentMatcher = new IntrospectionFragmentMatcher({
	introspectionQueryResultData
});

export {
	fragmentMatcher
};